<div class="nowifi">
  <!-- <mat-icon>signal_wifi_0_bar</mat-icon> -->
  <span>Internet connection unavailable</span>
</div>